import React, { useState, useEffect } from "react";
import moment from "moment-timezone";

import ModalBorrar from "../modals/modalDelete";
import Request from "../../core/httpClient";
import DinamicModal from "../../components/dinamicModal/dinamicModal";
import cogoToast from "cogo-toast";

import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import { useSuperCore } from "../../hooks/useSuperCore";

registerLocale("es", es);

const request = new Request();


function ReservationTable2({ reservas: reservasProp, page: pageProp, pageLength, user: userProp, escritura, reload }) {
  const [reservas, setReservas] = useState(reservasProp);
  const [page, setPage] = useState(pageProp);
  const [comentarios, setComentarios] = useState("");
  const [fianza, setFianza] = useState(null);
  const [fianzaDevolucion, setFianzaDevolucion] = useState(null);
  const [fecha, setFecha] = useState(new Date());
  const [minDay, setMinDay] = useState(new Date());
  const [horarios, setHorarios] = useState([]);
  const [idHorario, setIdHorario] = useState(0);
  const [user, setUser] = useState(userProp);
  const [horarioOcupado, setHorarioOcupado] = useState({});
  const [idReserva, setIdReserva] = useState(0);
  const [fechaReservaCreacion, setFechaReservaCreacion] = useState(null);
  const [fechaReservaCancelacion, setFechaReservaCancelacion] = useState(null);
  const [reservaCreacion, setReservaCreacion] = useState("");
  const [cancelada, setCancelada] = useState("");
  const [reservaCancelacion, setReservaCancelacion] = useState("");
  const [fechaDevolucion, setFechaDevolucion] = useState(null);
  const [area, setArea] = useState("");
  const [unidad, setUnidad] = useState("");
  const [cantidad, setCantidad] = useState(0);
  const [recibido, setRecibido] = useState("");
  const [devuelto, setDevuelto] = useState("");
  const [fianzaDisabled, setFianzaDisabled] = useState(false);
  const [fianzaDevolucionDisabled, setFianzaDevolucionDisabled] = useState(false);
  const [fechaZona, setfechaZona] = useState(null);


  const [isFianzaDevolucionSet, setIsFianzaDevolucionSet] = useState(false);
  const [loadingSave, setLoadingSave] = useState(false);
  const [message, setMessage] = useState("");
  const [idArea, setIdArea] = useState(0);




  const { getUserInfo, openModal, closeModalDelete, openModalDelete } = useSuperCore();
  // sincronizar props con estado
  useEffect(() => { setPage(pageProp); }, [pageProp]);
  useEffect(() => { setReservas(reservasProp); }, [reservasProp]);
  useEffect(() => { setUser(userProp); }, [userProp]);

  const convertFecha = (f) => {
    if (!f) return ""; // si la fecha es nula, devuelvo una cadena vacía
    return `${f.getFullYear()}-${f.getMonth() + 1 < 10 ? `0${f.getMonth() + 1}` : f.getMonth() + 1}-${f.getDate()}`;
  };


  const getHorarios = async (reserva) => {
    setHorarios([]);
    setIdHorario(0);

    const f = fecha;
    const fechaStr = convertFecha(f);

    const data = { id: reserva.id_espacio, fecha: fechaStr, dif: 1 };
    const response = await request.post("/commonArea/get/available/schedule", data);

    if (response.error || response.empty) {
      setHorarios([]);
      cogoToast.info("No se encontraron horarios para la fecha seleccionada.", { position: "bottom-right" });
      return;
    }

    let horariosIncompletos = response.commonSchedules || [];
    if (horariosIncompletos.length > 0) setIdHorario(horariosIncompletos[0].id_horario);

    if (fechaZona && convertFecha(fecha) === convertFecha(fechaZona)) {
      horariosIncompletos.unshift(horarioOcupado);
      setIdHorario(horarioOcupado.id_horario);
    }
    setHorarios(horariosIncompletos);
  };
  const changeHorario = (event) => {
    setIdHorario(event.target.value);
  };



  const delimitarSeleccionFechas = async (areaSeleccionada) => {
    let min_day = moment().add(parseInt(areaSeleccionada.dias_anticipacion), "days");
    setMinDay(min_day.toDate());
  };
  const setReservaData = async (reserva) => {
    await delimitarSeleccionFechas(reserva);

    const fechaZona = new Date(moment(reserva.fecha_reserva).tz("GMT").format("YYYY/MM/DD"));
    setFecha(fechaZona);
    setfechaZona(fechaZona);

    // Campos de área y unidad
    setArea(reserva.nombre);
    setUnidad(reserva.numero_registro);

    setReservaCreacion(reserva.reserva_creacion);
    setFechaReservaCreacion(moment(reserva.fecha_reserva_creacion).format("DD/MM/YYYY h:mm a"));
    setFechaReservaCancelacion(moment(reserva.fecha_reserva_cancelacion).format("DD/MM/YYYY h:mm a"));
    setCancelada(reserva.cancelada);
    setReservaCancelacion(reserva.reserva_cancelacion);

    setIdReserva(reserva.id_reserva);
    setIdHorario(reserva.IdHorario);

    setHorarioOcupado({
      id_espacio: reserva.id_espacio,
      id_horario: reserva.IdHorario,
      descripcion: reserva.descripcion,
    });

    setFianza(reserva.fianza_cobrada ? reserva.fianza_cobrada : 0);
    setFianzaDevolucion(reserva.fianza_devolucion ? reserva.fianza_devolucion : null);
    setIsFianzaDevolucionSet(reserva.fianza_devolucion > 0);

    setFianzaDevolucionDisabled(!(reserva.fianza_devolucion === 0 || reserva.fianza_devolucion === null));
    setFianzaDisabled(!(reserva.fianza_cobrada === 0 || reserva.fianza_cobrada === null));

    setComentarios(reserva.comentarios);
    setRecibido(reserva.nombre_recibido);
    setDevuelto(reserva.nombre_devolucion);

    setIdArea(reserva.id_espacio);
    setCantidad(reserva.cantidad);
    setFechaDevolucion(reserva.fecha_devolucion);
  };


  const beforeOpenModal = async (reserva) => {
    await setReservaData(reserva);   // actualiza todos los estados con los datos de la reserva
    await getHorarios(reserva);      // carga los horarios disponibles
    openModal("editReservation");    // tu lógica para abrir el modal
  };


  const beforeOpenModalDelete = async (reserva) => {
    const userInfo = await getUserInfo();
    setUser(userInfo.info);
    setIdReserva(reserva.id_reserva);
    openModalDelete("deleteReservationAreas"); // ahora sí abre el modal
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoadingSave(true);

    if (fianzaDevolucion > fianza) {
      cogoToast.warn("La cantidad devuelta debe ser igual o menor al depósito de la fianza.", { position: "bottom-right" });
      setLoadingSave(false);
      return;
    }

    const data = {
      fechaActualizacion: moment().format("YYYY-MM-DD"),
      comentarios,
      idReserva,
      idUserDev: parseInt(user.id_usuario),
      fianzaDev: fianzaDevolucion,
      fechaDev: fechaDevolucion
        ? fechaDevolucion
        : fianzaDevolucion
          ? moment().format("YYYY-MM-DD")
          : "",
    };

    const response = await request.post("/commonArea/update/reservation", data);

    if (response.error) {
      cogoToast.error("No se pudo editar reserva.", { position: "bottom-right" });
      setLoadingSave(false);
      return;
    }

    if (response.created) {
      // cerrar modal
      cogoToast.success("Datos actualizados correctamente.", { position: "bottom-right" });
      reload();
    }

    setLoadingSave(false);
  };


  const deleteReservation = async (id) => {
    const data = { Idreserva: id, id_usuario: user.id_usuario };
    const response = await request.post("/commonArea/delet/reservation", data);

    if (response.error || response.empty) {
      cogoToast.error("No se pudo eliminar la reservación.", { position: "bottom-right" });
    }

    if (response.deleted) {
      cogoToast.success("Reservación eliminada.", { position: "bottom-right" });
    }
    // cerrar modal de borrado
    reload();
  };

  const renderModalEdit = () => (
    <div className="w-full space-y-6">
      {/* Área reservada */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Área reservada:</label>
        <input
          type="text"
          value={area}
          disabled
          className="input-edit-select-full"
        />
      </div>

      {/* Unidad */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Unidad:</label>
        <input
          type="text"
          value={unidad}
          disabled
          className="input-edit-select-full"
        />
      </div>

      {/* Fecha y Horario */}
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Fecha:</label>
          <input
            value={moment(fecha).format("DD/MM/YYYY")}
            disabled
            className="input-edit-select-full"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Horario:</label>
          <select
            value={idHorario}
            onChange={changeHorario}
            disabled
            required
            className="input-edit-select-full"
          >
            {horarios.map((horario, key) => (
              <option value={horario.id_horario} key={key}>
                {horario.descripcion}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Reservas por vivienda */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Reservas por vivienda:</label>
        <input
          type="text"
          value={cantidad}
          disabled
          className="input-edit-select-full"
        />
      </div>

      {/* Depósito fianza */}
      {fianza > 0 && (
        <div className="space-y-6">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Depósito fianza:</label>
              <input
                type="number"
                min={0}
                value={fianza}
                onChange={(e) => setFianza(e.target.value)}
                disabled={fianzaDisabled}
                className="input-edit-select-full"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Recibido por:</label>
              <input
                type="text"
                value={recibido}
                disabled
                className="input-edit-select-full"
              />
            </div>
          </div>

          {/* Devolución fianza */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Devolución fianza:</label>
              <input
                type="number"
                min={0}
                value={fianzaDevolucion}
                onChange={(e) => setFianzaDevolucion(e.target.value)}
                disabled={fianzaDevolucionDisabled}
                className="input-edit-select-full"
              />
            </div>
            {isFianzaDevolucionSet && (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Devuelto por:</label>
                <input
                  type="text"
                  value={devuelto ? devuelto : user.usuario}
                  disabled
                  className="input-edit-select-full"
                />
              </div>
            )}
          </div>


          {/* Fecha de creación */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Fecha de Creación:</label>
              <input
                type="text"
                value={fechaReservaCreacion || ""}
                disabled
                className="input-edit-select-full"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Creado por:</label>
              <input
                type="text"
                value={reservaCreacion}
                disabled
                className="input-edit-select-full"
              />
            </div>
          </div>

          {/* Cancelación */}
          {cancelada === "Cancelada" && (
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Fecha de Cancelación:</label>
                <input
                  type="text"
                  value={fechaReservaCancelacion || ""}
                  disabled
                  className="input-edit-select-full"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Cancelado por:</label>
                <input
                  type="text"
                  value={reservaCancelacion}
                  disabled
                  className="input-edit-select-full"
                />
              </div>
            </div>
          )}

          {/* Comentarios */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Comentarios:</label>
            <textarea
              rows="3"
              value={comentarios}
              onChange={(e) => setComentarios(e.target.value)}
              className="input-edit-select-full 
               focus:border-purple-500 focus:ring focus:ring-purple-500 focus:ring-opacity-50"
            ></textarea>
          </div>







        </div>
      )}
    </div>
  );


  return (
    <div className="w-full flex flex-col space-y-6" id="card-owners">
      <div className="overflow-x-auto">
        <table className="min-w-full border border-gray-200 rounded-md shadow-sm text-sm">
          <thead className="bg-gray-100 sticky top-0">
            <tr className="text-left text-gray-700">
              <th className="px-4 py-2">Área reservada</th>
              <th className="px-4 py-2">Fecha</th>
              <th className="px-4 py-2">Vivienda</th>
              <th className="px-4 py-2">Horario</th>
              <th className="px-4 py-2">Cancelada</th>
              <th className="px-4 py-2 text-center">Ver</th>
              <th className="px-4 py-2 text-center">Cancelar</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {reservas
              .slice((page - 1) * pageLength, page * pageLength)
              .map((reserva, key) => (
                <tr key={key} className="hover:bg-gray-50">
                  <td className="px-4 py-2">{reserva.nombre}</td>
                  <td className="px-4 py-2">{moment(reserva.fecha_reserva).tz("GMT").format("DD/MM/YYYY")}</td>
                  <td className="px-4 py-2">{reserva.numero_registro}</td>
                  <td className="px-4 py-2">{reserva.descripcion}</td>
                  <td className="px-4 py-2">
                    <input
                      type="checkbox"
                      checked={reserva.cancelada ? true : false}
                      readOnly
                      disabled
                      className="h-4 w-4 text-red-600 border-red-300 rounded focus:ring-red-500 bg-red-400"
                    />
                  </td>
                  <td className="px-4 py-2 text-center">
                    <button
                      className="inline-flex items-center justify-center rounded-md bg-purple-400 text-white px-2 py-1 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500"
                      type="button"
                      onClick={() => beforeOpenModal(reserva)}
                    >
                      <i className="fas fa-eye text-xs" />
                    </button>
                  </td>
                  <td className="px-4 py-2 text-center">
                    <button
                      className={`inline-flex items-center justify-center rounded-md px-2 py-1 ${escritura
                          ? "bg-red-400 text-white hover:bg-red-700 focus:ring-2 focus:ring-red-500"
                          : "bg-gray-300 text-gray-500 cursor-not-allowed"
                        }`}
                      type="button"
                      onClick={() => beforeOpenModalDelete(reserva)}
                      disabled={!escritura}
                    >
                      <i className="fas fa-ban text-sm" />
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>

      {/* Modal ver reserva */}
      <DinamicModal
        idModal="editReservation"
        sizeModalContainer="big"
        title="Ver reserva"
        success={handleSubmit}
        btnTextSuccess="ACTUALIZAR"
        btnTextCancel="CANCELAR"
        showBtnSuccess={escritura}
        showBtnCancel={true}
        loadingSave={loadingSave}
        message={message}
      >
        {renderModalEdit()}
      </DinamicModal>

      {/* Modal borrar */}
      <ModalBorrar
        name="deleteReservationAreas"
        id={idReserva}
        delete={deleteReservation}
        message="¿Está seguro de cancelar la reservación?"
      />
    </div>
  );
}

export default ReservationTable2;
